import React, { useState, useEffect } from 'react'
import {
    InputBase,
    Grid,
    Button
} from "@material-ui/core";
import useStyles from "./styles";
import { SearchOutlined as SearchIcon } from '@material-ui/icons';
import ClearIcon from '@material-ui/icons/Clear';
import SearchGrid from '../../../components/table/SearchGrid';
import Breadcrums from '../../../components/BreadCrums/breadcrums';
import TopSpacer from '../../../components/Common/spacer/TopSpacer';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { PostDataAPI } from '../../../Services/APIService';
import Loader from '../../../components/Loader/Loader';
import { ActionDialog } from "../../../components/ActionDialog/ActionDialog";
import { withSnackbar } from "../../../components/Message/Alert";
import AddNewUser from './components/addNewUser';
import { saveActivlityLogInfo } from '../../../components/Common/Extensions';


function Users({ trackingType, ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    const [editItem, setEditItem] = useState({});
    const [addNewUserDialog, setAddNewUserDialog] = useState(false);

    //action dialog
    const [actiondialogState, setActionDialogState] = useState({
        showHide: false, type: "confirm", message: "",
    })

    const showActionDialog = (message, type, OnOkCallback, OnCancellCallback) => {
        setActionDialogState(prevState => ({
            ...prevState,
            type: type,
            showHide: true,
            message: message,
            onClickOk: OnOkCallback,
            OnClickCancel: OnCancellCallback
        }));
    }

    const deleteUser = (item) => {
        console.log(item)
        if (item.isCorporateOwner == 1) {
            logUserActivity(
                "User Delete Blocked",
                `User attempted to delete corporate owner ${getUserSummary(item)}, but corporate owner must be changed before deletion`
            );
            showMessage("Error", "[" + item.firstName + " " + item.lastName +"] is currently the corporate owner. Please assign another user as the corporate owner before attempting to delete the account.", "error", 3000);
            return true;
        }
        else {
            logUserActivity(
                "User Delete Confirmation Opened",
                `User opened delete confirmation for ${getUserSummary(item)}`
            );
            showActionDialog("Warning: Deleting this user will result in permanent loss of system access for this user. Are you sure you want to delete?", "confirm", function () {
                var params = { userID: item.userId, accountNumber: accountNumber }
                setIsLoading(true);
                PostDataAPI("fwuser/delete", params, true).then((result) => {
                    if (result.success) {
                        showMessage("Success", "User deleted successfully", "success", 3000);
                        loadUsersGrid();
                    } else {
                        showMessage("Error", result.message, "error", 3000);
                    }
                    setIsLoading(false);
                })
            });
        }
    }
    const editUser = (item) => {
        logUserActivity(
            "User Edit Dialog Opened",
            `User opened edit user dialog for ${getUserSummary(item)}`
        );
        setEditItem(item);
        setAddNewUserDialog(true);
    }
    const closeAddUser = () => {
        setEditItem({});
        setAddNewUserDialog(false);
    }
    const closeUserDialog = () => {
        logUserActivity(
            "User Dialog Closed",
            `User closed ${editItem?.userId ? "edit" : "add"} user dialog${editItem?.userId ? ` for ${getUserSummary(editItem)}` : ""}`
        );
        closeAddUser();
    }
    const handleSuccessClose = (message) => {
        setEditItem({});
        closeAddUser();
        showMessage("Success", message, "success", 3000);
        loadUsersGrid();
    }
    const addUser = () => {
        logUserActivity(
            "User Add Dialog Opened",
            "User opened add user dialog"
        );
        setEditItem({});
        setAddNewUserDialog(true);
    }
    const [isDataGridUpdate, setIsDataGridUpdate] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [usersData, setUsersData] = useState([]);


    const handleDataGridUpdate = () => {
        setIsDataGridUpdate(!isDataGridUpdate);
    }

    const [searchFilter, setValue] = useState('');
    const handleSearch = (e) => {
        const currValue = e.target.value;
        if (currValue.trim().length > 0 || currValue == '') {
            setValue(currValue);
            handleDataGridUpdate()
        }
    }
    // Function to clear the input field
    const handleClearInput = (name) => {
        if (searchFilter.trim())
            logUserActivity(
                "User Search Cleared",
                `User cleared user search filter "${searchFilter.trim()}"`
            );
        setValue('');
        handleDataGridUpdate();
    };
    const userInfoJson = sessionStorage.getItem('user_info');
    const userInfo = JSON.parse(userInfoJson);
    const associateId = userInfo.user.associateId;
    const accountNumber = userInfo.user.accountNumber;
    const getUserName = (item) => {
        const name = `${item?.firstName || ""} ${item?.lastName || ""}`.trim();
        return name || "selected user";
    };
    const getUserSummary = (item) => {
        const parts = [`user ${getUserName(item)}`];
        if (item?.userId)
            parts.push(`User ID: ${item.userId}`);
        if (item?.emailAddress)
            parts.push(`Email: ${item.emailAddress}`);
        if (item?.phoneNumber)
            parts.push(`Phone: ${item.phoneNumber}`);
        return parts.join(", ");
    };
    const logUserActivity = (activity, details) => {
        saveActivlityLogInfo("User Setup", activity, details, accountNumber, associateId);
    };
    const logUserSearch = () => {
        if (!searchFilter.trim())
            return;

        logUserActivity(
            "User Search Filter Applied",
            `User searched corporate users for "${searchFilter.trim()}"`
        );
    };
    const loadUsersGrid = () => {
        console.log(userInfo.user);
        debugger;
        setIsLoading(true);
        var params = {
            associateId: associateId,
            userId: userInfo.user.userId
        };
        PostDataAPI("fwuser/loadGrid", params).then((result) => {
            if (result.success && result.data != null) {
                console.log(result.data)
                setUsersData(
                    result.data.map((item, i) => {
                        item.completeAddress = (
                            (item.address1 ?? '') +
                            (item.address2 ? ' ' + item.address2 : '') +
                            (item.city ? ' ' + item.city : '') +
                            (item.state ? ', ' + item.state : '') +
                            (item.zipCode ? ' ' + item.zipCode : '')
                        ).trim();
                        item.fullName = item.firstName ? item.firstName + ' ' + item.lastName : '';
                        return { ...item };
                    }));
                
            }
            else {
                setUsersData([]);
            }
            handleDataGridUpdate();
            setIsLoading(false);

        })
    }

    useEffect(() => {
        loadUsersGrid();
    }, []);

    return (
        <>
            {isLoading ? <Loader></Loader> : ''}
            <TopSpacer></TopSpacer>

            <div className={classes.header}>

                <Grid container alignItems="baseline">
                    <Grid item lg={12}>
                        <Breadcrums parentLink={"Setup"} currentLink={"Users"} isBack={true}></Breadcrums>
                    </Grid>
                </Grid>
            </div>

            <Grid container className={classes.container}>
                <h1 className={classes.heading}>
                    Users
                </h1>
            </Grid>



            <Grid row className={classes.gridHeader}>
                <div className={classes.gridActions}>
                    <Button className={classes.changeBtn} onClick={() => addUser()}><AddCircleOutlineIcon style={{ marginRight: '6px' }} /> Add New</Button>
                </div>
                <div className={classes.gridActions} style={{ marginRight: '7px' }} >
                    <InputBase
                        value={searchFilter}
                        placeholder="Search"
                        className="grid-search-input"
                        endAdornment={searchFilter ? <ClearIcon style={{ cursor: 'pointer' }} onClick={() => { handleClearInput('search') }} /> : ''}
                        startAdornment={<SearchIcon />}
                        onChange={handleSearch}
                        onBlur={logUserSearch}
                        autoComplete={'off'}
                    />
                </div>

            </Grid>



            <Grid row className={classes.container} >
                <SearchGrid columns="users"
                    list={usersData}
                    noRecordMsg="No record exists"
                    Icon={true}
                    isUpdate={isDataGridUpdate}
                    filter={searchFilter}
                    onDeleteClick={deleteUser}
                    onEditClick={editUser}
                />
            </Grid>

            {addNewUserDialog ?
                <AddNewUser
                    dialogOpenClose={addUser}
                    handleClose={closeUserDialog}
                    handleSuccessClose={handleSuccessClose}
                    data={editItem}
                ></AddNewUser>
                : ''}

            <ActionDialog
                type={actiondialogState.type}
                message={actiondialogState.message}
                actiondialogOpenClose={actiondialogState.showHide}
                onSubmit={actiondialogState.onClickOk}
                onCancel={() =>
                    setActionDialogState(prevState => ({
                        ...prevState, showHide: false
                    }))
                }
                onClose={() => setActionDialogState(prevState => ({
                    ...prevState, showHide: false
                }))

                }
            />

        </>
    )

}

export default withSnackbar(Users);
